import React from 'react';
import { FilterFieldType } from './CustomFilter';
import { Nav } from 'react-bootstrap';

interface BooleanAdvancedOptionProps {
	field: FilterFieldType;
	advOption: FilterFieldType['advancedOptions'][number];
	activeFilters: { [key: string]: string[] };
	setActiveFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const BooleanAdvancedOption: React.FC<BooleanAdvancedOptionProps> = ({ field, advOption, activeFilters, setActiveFilters }) => {
	const advOptionName = field.name === advOption.name ? field.name : `${field.name}_${advOption.name}`;
	const filterValue = activeFilters[advOptionName]?.[0];

	const initialActiveKey = filterValue ? `${advOptionName}-${filterValue}` : undefined;

	const [activeKey, setActiveKey] = React.useState<string>(initialActiveKey);

	return (
		<div
			style={{
				borderRadius: '8px',
				padding: '0.5rem',
				border: '1px solid #C7CFD7',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}
		>
			{field.booleanLabel || `${advOption.switchLabelPrefix} ${field.pluralLabel} ${advOption.switchLabelSuffix}`}

			<Nav variant="pills">
				{advOption.options.map((option) => {
					const advOptionName = field.name === advOption.name ? field.name : `${field.name}_${advOption.name}`;
					const advOptionValue = option.value;
					const key = `${advOptionName}-${advOptionValue}`;

					return (
						<Nav.Item key={key}>
							<Nav.Link
								eventKey={key}
								active={activeKey === key || (!activeKey && key === `${advOptionName}-none`)}
								onClick={() => {
									const isActive = activeFilters[advOptionName]?.includes(advOptionValue);

									if (!isActive) {
										if (advOptionValue !== 'none') {
											setActiveFilters((prev) => ({
												...prev,
												[advOptionName]: [advOptionValue],
											}));
										} else {
											const { [advOptionName]: _, ...rest } = activeFilters;
											setActiveFilters(rest);
										}
										setActiveKey(key);
									}
								}}
							>
								{option.label}
							</Nav.Link>
						</Nav.Item>
					);
				})}
			</Nav>
		</div>
	);
};

export default BooleanAdvancedOption;
